import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import isEmpty from 'lodash/isEmpty';
import profileFormSchema from './profileFormSchema';
import { updateProfile, cancelEditProfile } from '../../actions/profile';

const useStyles = makeStyles(theme => ({
  form: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  wrapper: {
    marginTop: theme.spacing(3),
  },
  title: {
    marginBottom: theme.spacing(3),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  paper: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
  },
  buttonRow: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

export const ProfileForm = props => {
  // eslint-disable-next-line no-shadow
  const { profile, updateProfile, cancelEditProfile } = props;

  const classes = useStyles();

  const isEditing = !isEmpty(profile);

  const initialValues = {
    name: profile.name || '',
    email: profile.email || '',
    picture: profile.picture || '',
  };

  return (
    <>
      <Container className={classes.wrapper}>
        <Paper className={classes.paper}>
          <Formik
            initialValues={initialValues}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              if (isEditing) {
                updateProfile(profile.user_id, values);
              }
            }}
            validationSchema={profileFormSchema}
          >
            {formikProps => {
              const {
                values,
                touched,
                errors,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
              } = formikProps;
              return (
                <form autoComplete="off" onSubmit={handleSubmit}>
                  <div className={classes.form}>
                    <Typography variant="h3" className={classes.title}>
                      Edit Profile
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={12}>
                        <TextField
                          required
                          error={errors.name ? touched.name : null}
                          className={classes.textField}
                          label="Name"
                          name="name"
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          variant="outlined"
                          helperText={errors.name && touched.name ? errors.name : ''}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <TextField
                          required
                          error={errors.email ? touched.email : null}
                          className={classes.textField}
                          label="Email"
                          name="email"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          variant="outlined"
                          helperText={errors.email && touched.email ? errors.email : ''}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <TextField
                          className={classes.textField}
                          label="Picture"
                          name="picture"
                          value={values.picture}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          variant="outlined"
                          helperText={errors.picture && touched.picture ? errors.picture : ''}
                          fullWidth
                        />
                      </Grid>
                    </Grid>
                  </div>
                  <div className={classes.buttonRow}>
                    <Button
                      onClick={cancelEditProfile}
                      className={classes.button}
                      disabled={isSubmitting}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      className={classes.button}
                      disabled={isSubmitting}
                    >
                      Update
                    </Button>
                  </div>
                </form>
              );
            }}
          </Formik>
        </Paper>
      </Container>
    </>
  );
};

ProfileForm.defaultProps = {
  profile: {},
  updateProfile: () => {},
  cancelEditProfile: () => {},
};

ProfileForm.propTypes = {
  profile: PropTypes.shape({
    user_id: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    picture: PropTypes.string,
  }),
  updateProfile: PropTypes.func,
  cancelEditProfile: PropTypes.func,
};

const mapStateToProps = state => {
  const { profile } = state;
  return { profile: profile.profile };
};

const mapDispatchToProps = {
  updateProfile,
  cancelEditProfile,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfileForm);
